module.exports = __webpack_public_path__ + "static/media/Interview_Patrick_Mayrhofer.266effcd.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle26/Interview_Patrick_Mayrhofer.mp4
 ** module id = 386
 ** module chunks = 0
 **/